import React from 'react';

export const ErrorState = ({ 
  message = 'Something went wrong', 
  onRetry = null,
  fullScreen = false 
}) => {
  const containerClass = fullScreen
    ? 'flex items-center justify-center h-screen p-6'
    : 'py-12 px-6';

  return (
    <div className={containerClass} data-testid="error-state">
      <div className="max-w-md mx-auto text-center">
        <div className="text-red-500 text-5xl mb-4">⚠️</div>
        <p className="text-gray-900 font-semibold mb-2">Error</p>
        <p className="text-gray-600 mb-4">{message}</p>
        {onRetry && (
          <button 
            onClick={onRetry}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Retry
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorState;
